import React from "react";

import {
  Box,
  Button,
  Dialog,
  DialogContent,
  FormControlLabel,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import styels from "../../styles/components/qcsubmittedvideosinquiringfilter.module.scss";
import modalstyle from "../../styles/layout/modal/qcsubmittedvideosinquiringfiltermodal.module.scss";

import CalenderIcon from "../../public/assets/icons/CalenderIcon";
import FilterIcon from "../../ui/Icons/FilterIcon";
import MuiModalWrapper from "../../ui/Modal/MuiModalWrapper";
import RefreshIconBlack from "../../ui/Icons/RefreshIconBlack";
import RefreshIconBlue from "../../ui/Icons/RefreshIconBlue";
import SelectDropDown from "../../ui/Icons/SelectDropDown";
import ResetIcon from "../../public/assets/icons/ResetIcon";
import dropdownStyles from "../../lib/functions/dropwdownstyles";

import { emptyHandle, getDateApiFormat } from "../../lib/functions/utils.lib";
import {
  setUserId,
  setDuplicates,
  setHasNote,
  setUnreachableSubmitter,
  setPeopleAppearing,
  setPersonWhoFilmed,
  setSubmitOtherWebsite,
  setAgreementWithAnotherCompany,
  setFrom,
  setTo,
} from "../../redux-toolkit/slices/qc/qc.submitted.inquiring.slice";
import { useEffect } from "react";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import { useState } from "react";

const dialogContainer = {
  [`.MuiDialog-container`]: {
    alignItems: "flex-start",

    [`.MuiDialog-paper`]: {
      marginTop: "72px",
      boxShadow: "none",
      borderRadius: "10px !important",
      [`.MuiDialogContent-root`]: {
        padding: "0 11px",
      },
    },
  },
};

import countries from "countries-list";
import useCalenderFilter from "../../hooks/useCalenderFilter";
import CalenderDate from "../../pages/Calender";
import dayjs from "dayjs";

export default function QcSubmittedVideosInquiringFilter({
  leftItems,
  filterActive,
  handleTriggreFetch,
  handleClearFilterModal,
  filterRefetch,
  openFilterModal,
  setOpenFilterModal,
  datas,
}) {
  const handleOpen = () => setOpenFilterModal(true);
  const handleClose = () => setOpenFilterModal(false);

  const countryNames = Object.values(countries.countries).map(
    (country) => country.name
  );

  const calenderContainerId = "calender-input-filter-row";
  const {
    calenderFilter,
    DateFilterRangeList,
    calenderFilterShowValue,
    changeCalenderFilter,
    resetCalender,
    confirmedCalenderValue,
    calenderValue,
    confirmCalenderTwo,
    dateRangeFilter: {
      dateRangeFilterAnchor,
      openedDateRangeFilter,
      handleOpenDateRangeFilter,
      handleCloseDateRangeFilter,
    },
  } = useCalenderFilter({
    containerId: calenderContainerId,
  });

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (calenderValue) {
      if (calenderValue[0]) {
        dispatch(setFrom(getDateApiFormat(calenderValue[0]["$d"])));
      }
      if (calenderValue[1]) {
        dispatch(setTo(getDateApiFormat(calenderValue[1]["$d"])));
      }
      handleTriggreFetch();
    }
  }, [calenderValue]);

  const {
    user_id,
    month,
    year,
    duplicates,
    has_note,
    unreachable_submitter,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    from,
    to,
    submit_place,
  } = useAppSelector((s) => s.qcSubmittedInquiringSlice);

  const { acquisitors } = useAppSelector((s) => s.appStateSlice);

  const [mockMonth, setMockMonth] = useState();
  const [mockUser, setMockUser] = useState();

  return (
    <>
      <Box className={styels.editorFilterWrapper}>
        {!filterActive ? (
          <Box className={styels.table_left2}>
            {leftItems}
            <Box className="commonSearchBar_modal">
              <p>
                Showing videos for{" "}
                {calenderFilter ? (
                  <>
                    <Box
                      className={`dayList ${
                        openedDateRangeFilter ? "date-black" : "date-blue"
                      }`}
                    >
                      <Button
                        aria-haspopup="true"
                        onClick={handleOpenDateRangeFilter}
                      >
                        {calenderFilter?.name}
                      </Button>
                      <Menu
                        anchorEl={dateRangeFilterAnchor}
                        open={openedDateRangeFilter}
                        onClose={handleCloseDateRangeFilter}
                        className="dateList"
                      >
                        {DateFilterRangeList.map((filter) => {
                          if (filter != calenderFilter) {
                            return (
                              <MenuItem
                                onClick={changeCalenderFilter(filter)}
                                key={filter.name}
                                selected={filter === calenderFilter}
                              >
                                {filter.name}
                              </MenuItem>
                            );
                          }
                        })}
                      </Menu>
                    </Box>
                    <span className="dateList">
                      ({calenderFilterShowValue})
                    </span>
                  </>
                ) : (
                  <>
                    the period from{" "}
                    {confirmedCalenderValue?.[0] ? (
                      <span className="dayList">
                        {dayjs(confirmedCalenderValue?.[0]).format("LL")}
                      </span>
                    ) : null}{" "}
                    to{" "}
                    {calenderValue?.[1] ? (
                      <span className="dayList">
                        {dayjs(confirmedCalenderValue?.[1]).format("LL")}
                      </span>
                    ) : null}
                  </>
                )}
              </p>
              {calenderFilter?.name !== "All time" ? (
                <span className="reset_picker" onClick={resetCalender}>
                  <svg
                    width="11"
                    height="11"
                    viewBox="0 0 11 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.5 10C7.975 10 10 7.975 10 5.5C10 3.025 7.975 1 5.5 1C3.025 1 1 3.025 1 5.5C1 7.975 3.025 10 5.5 10Z"
                      stroke="currentColor"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M4.22705 6.7832L6.77263 4.23762"
                      stroke="currentColor"
                      strokeWidth="0.8"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M6.77263 6.76238L4.22705 4.2168"
                      stroke="currentColor"
                      strokeWidth="0.8"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  reset
                </span>
              ) : null}
            </Box>
          </Box>
        ) : (
          <p className={styels.moreFilter}>
            Showing videos for one or more selected filters.
          </p>
        )}

        <Box className={styels.editorFilterButtonGroup}>
          <Button className={styels.calenderBtn} onClick={handleOpen}>
            <FilterIcon />{" "}
          </Button>
          <Button className={`${styels.calenderBtn} ${styels.calenderVerified}`}>
            <CalenderDate confirmCalender={confirmCalenderTwo} />
          </Button>
          <Button className={styels.allVideo}>
            All videos: <span>{emptyHandle(datas?.total)}</span>
          </Button>
        </Box>
      </Box>

      <Dialog
        open={openFilterModal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "787px",
            position: "relative",
          },
        }}
        sx={dialogContainer}
      >
        <DialogContent>
          <Box className={modalstyle.dialog_wrapper}>
            <Box className={modalstyle.dialog_top}>
              <Typography variant="h3" className={modalstyle.heading}>
                Filter
              </Typography>
              <Button
                onClick={handleClearFilterModal}
                type="button"
                className={modalstyle.refresh_btn}
              >
                <Typography variant="caption" className={modalstyle.icon}>
                  <RefreshIconBlack />
                </Typography>
                <Typography variant="caption" className={modalstyle.text}>
                  Clear
                </Typography>
              </Button>
            </Box>
            <Box className={modalstyle.dialog_middle}>
              <Box className={modalstyle.form_wrapper}>
                <form>
                  <Box className={modalstyle.form_one}>
                    <Box
                      className={`${modalstyle.form_row} ${modalstyle.radio_row}`}
                    >
                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.unreachGroup}`}
                      >
                        <label className={modalstyle.innerLabel}>
                          <Typography variant="caption">
                            Unreachable Submitter?
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() =>
                              dispatch(setUnreachableSubmitter(null))
                            }
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            value={unreachable_submitter}
                            onChange={(e) =>
                              dispatch(setUnreachableSubmitter(e.target.value))
                            }
                            row
                          >
                            <FormControlLabel
                              value="yes"
                              control={<Radio />}
                              label="Yes"
                            />
                            <FormControlLabel
                              value="no"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                        </Box>
                      </Box>

                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.hasGroup}`}
                      >
                        <label className={modalstyle.innerLabel}>
                          <Typography variant="caption">Has Notes?</Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() => dispatch(setHasNote(null))}
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            onChange={(e) =>
                              dispatch(setHasNote(e.target.value))
                            }
                            value={has_note != null ? has_note : null}
                            row
                          >
                            <FormControlLabel
                              value="yes"
                              control={<Radio />}
                              label="Yes"
                            />
                            <FormControlLabel
                              value="no"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                        </Box>
                      </Box>

                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.purchaseGroup}`}
                      >
                        <label className={modalstyle.innerLabel}>
                          <Typography variant="caption">
                            Show potential duplicates only?
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() => dispatch(setDuplicates(null))}
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            // defaultValue="female"
                            name="duplicates"
                            value={duplicates != null ? duplicates : null}
                            onChange={(e) =>
                              dispatch(setDuplicates(e.target.value))
                            }
                          >
                            <Box className="filterFromControl">
                              <FormControlLabel
                                value="yes"
                                control={<Radio />}
                                label="Yes"
                              />
                              <FormControlLabel
                                value="no"
                                control={<Radio />}
                                label="No"
                              />
                            </Box>
                          </RadioGroup>
                        </Box>
                      </Box>
                    </Box>

                    <Box className={modalstyle.form_row}>
                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.groupAcquisitor}`}
                      >
                        <label>
                          <Typography variant="caption">Acquisitor</Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() => dispatch(setUserId(null))}
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.input_group}>
                          <Select
                            className="commonDropdown"
                            MenuProps={{
                              PaperProps: {
                                sx: dropdownStyles(134),
                              },
                            }}
                            displayEmpty
                            value={user_id}
                            renderValue={() => {
                              if (!user_id) {
                                return <span>Acquisitor</span>;
                              } else {
                                return <span>{mockUser.name}</span>;
                              }
                            }}
                            onChange={(e) => {
                              dispatch(setUserId(e.target.value.id));
                              setMockUser(e.target.value);
                            }}
                          >
                            {acquisitors?.map((aqs, i) => {
                              return (
                                <MenuItem key={i} value={aqs}>
                                  {aqs.name}
                                  <span>&nbsp;({aqs.role?.display_name})</span>
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  <Box className={modalstyle.form_two}>
                    <Box className={modalstyle.form_row}>
                      <Box className={modalstyle.form_group}>
                        <label>
                          <Typography variant="caption">
                            Are There People Appearing In The Video?
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() => dispatch(setPeopleAppearing(null))}
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            value={people_appearing}
                            onChange={(e) =>
                              dispatch(setPeopleAppearing(e.target.value))
                            }
                            row
                          >
                            <FormControlLabel
                              value="yes"
                              control={<Radio />}
                              label="Yes"
                            />
                            <FormControlLabel
                              value="no"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                    </Box>
                    <Box className={modalstyle.form_row}>
                      <Box className={modalstyle.form_group}>
                        <label>
                          <Typography variant="caption">
                            The Person Who Filmed This Video Is:
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() => dispatch(setPersonWhoFilmed(null))}
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            value={
                              person_who_filmed != null
                                ? person_who_filmed
                                : null
                            }
                            onChange={(e) =>
                              dispatch(setPersonWhoFilmed(e.target.value))
                            }
                            row
                          >
                            <FormControlLabel
                              value="Me"
                              control={<Radio />}
                              label="Me"
                            />
                            <FormControlLabel
                              value="A Family Member"
                              control={<Radio />}
                              label="A Family Member"
                            />
                            <FormControlLabel
                              value="A Friend"
                              control={<Radio />}
                              label="A Friend"
                            />
                            <FormControlLabel
                              value="Someone I Know"
                              control={<Radio />}
                              label="Someone I Know"
                            />
                            <FormControlLabel
                              value="A Dashcam"
                              control={<Radio />}
                              label="A Dashcam"
                            />
                            <FormControlLabel
                              value="A Security Camera"
                              control={<Radio />}
                              label="A Security Camera"
                            />
                            <FormControlLabel
                              value="Other: the kid of my friend"
                              control={<Radio />}
                              label={
                                <>
                                  Other: <span>the kind of my friend</span>
                                </>
                              }
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                    </Box>
                    <Box className={modalstyle.form_row}>
                      <Box className={modalstyle.form_group}>
                        <label>
                          <Typography variant="caption">
                            Did You Send/Submit/Upload This Video To A Website
                            And/Or Social Media Account?
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() =>
                              dispatch(setSubmitOtherWebsite(null))
                            }
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            value={
                              submit_other_website != null
                                ? submit_other_website
                                : null
                            }
                            onChange={(e) =>
                              dispatch(setSubmitOtherWebsite(e.target.value))
                            }
                            row
                          >
                            <FormControlLabel
                              value="No, I Did Not"
                              control={<Radio />}
                              label="No, I Did Not"
                            />
                            <FormControlLabel
                              value="Yes, Another Company's Website"
                              control={<Radio />}
                              label="Yes, Another Company's Website"
                            />
                            <FormControlLabel
                              value="Yes, A Facebook Page"
                              control={<Radio />}
                              label="Yes, A Facebook Page"
                            />
                            <FormControlLabel
                              value="Yes, A Twitter Account"
                              control={<Radio />}
                              label="Yes, A Twitter Account"
                            />
                            <FormControlLabel
                              value="Yes, An Instagram Account"
                              control={<Radio />}
                              label="Yes, An Instagram Account"
                            />
                            <FormControlLabel
                              value="Yes, A YouTube Channel"
                              control={<Radio />}
                              label="Yes, A YouTube Channel"
                            />
                            <FormControlLabel
                              value="Yes, A Snaphat Account"
                              control={<Radio />}
                              label="Yes, A Snaphat Account"
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                    </Box>
                    <Box className={modalstyle.form_row}>
                      <Box className={modalstyle.form_group}>
                        <label>
                          <Typography variant="caption">
                            Did You Sign A Licensing Agreement For This Video
                            With Another Company/Page?
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() =>
                              dispatch(setAgreementWithAnotherCompany(null))
                            }
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            value={
                              aggrement_with_another_company != null
                                ? aggrement_with_another_company
                                : null
                            }
                            name="aggrement_with_another_company"
                            onChange={(e) =>
                              dispatch(
                                setAgreementWithAnotherCompany(e.target.value)
                              )
                            }
                            row
                          >
                            <FormControlLabel
                              value="No, I Did Not"
                              control={<Radio />}
                              label="No, I Did Not"
                            />
                            <FormControlLabel
                              value="Yes, I Have Filled An Online Form"
                              control={<Radio />}
                              label="Yes, I Have Filled An Online Form"
                            />
                            <FormControlLabel
                              value="Yes, I Have Signed An Exclusive Agreement"
                              control={<Radio />}
                              label="Yes, I Have Signed An Exclusive Agreement"
                            />
                            <FormControlLabel
                              value="Yes, I Have Signed A Non-Exclusive Agreement"
                              control={<Radio />}
                              label="Yes, I Have Signed A Non-Exclusive Agreement"
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </form>
              </Box>
            </Box>

            <Box className={modalstyle.dialog_bottom}>
              <Box className={modalstyle.btn_holder}>
                <Button
                  type="button"
                  className={modalstyle.cancel_btn}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  onClick={filterRefetch}
                  type="button"
                  className={modalstyle.submit_btn}
                >
                  Filter <strong>now</strong>
                </Button>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
